import {Swiper} from 'swiper'

// timeline slider
let timelineSliders = $('.js-timeline-slider')
if (timelineSliders.length){

  timelineSliders.each((i, el)=> {

    let sliderC = $(el).closest('.js-block')
    let curSlide = sliderC.find('.js-current-slide')
    let nextB = sliderC.find('.js-next-slide')
    let prevB = sliderC.find('.js-prev-slide')

    let swiper = new Swiper(el, {
      slidesPerView: 1,
      //spaceBetween: 15,
      loop: true,
      breakpoints: {
        1600: {
          slidesPerView: 5,
        },
        1200: {
          slidesPerView: 4,
        },
        900: {
          slidesPerView: 3,
        },
        700: {
          slidesPerView: 2,
        },
      }
    });

    // navigation buttons
    nextB.click(()=> swiper.slideNext() )
    prevB.click(()=> swiper.slidePrev() )

    // slide change event
    swiper.on('slideChange', (slider)=> {
      curSlide.text(slider.realIndex + 1)
    });


  })

}
